/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ImageVersionTypeName = "large" | "master" | "medium" | "original" | "placeholder" | "small" | "thumb" | "zoom" | "%future added value";
export type PdpHead_item = {
    readonly microdata: string | null;
    readonly pdpURL: string | null;
    readonly localizedPdpUrl: string | null;
    readonly pdpMeta: {
        readonly title: string | null;
        readonly description: string | null;
        readonly ogTitle: string | null;
        readonly productPriceAmount: string | null;
        readonly productPriceCurrency: string | null;
    } | null;
    readonly photos: ReadonlyArray<{
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
            readonly type: {
                readonly name: ImageVersionTypeName | null;
            } | null;
        } | null> | null;
    } | null> | null;
    readonly isListingNotListed: boolean | null;
    readonly isMissingTranslatedItemTitle: boolean | null;
    readonly isPriceUponRequest: boolean | null;
    readonly seller: {
        readonly isInternal: boolean | null;
        readonly isAccessible: boolean | null;
    } | null;
    readonly isSold: boolean | null;
    readonly metrics: ReadonlyArray<{
        readonly value: string | null;
    } | null> | null;
    readonly " $refType": "PdpHead_item";
};
export type PdpHead_item$data = PdpHead_item;
export type PdpHead_item$key = {
    readonly " $data"?: PdpHead_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpHead_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "forcedCurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHead_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "forcedCurrency"
        }
      ],
      "kind": "ScalarField",
      "name": "microdata",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "pdpMetaItems",
      "kind": "LinkedField",
      "name": "pdpMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ogTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceCurrency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingNotListed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMissingTranslatedItemTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPriceUponRequest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "metricTypes",
          "value": [
            "LISTING_VIEWS"
          ]
        },
        {
          "kind": "Literal",
          "name": "timeRange",
          "value": "LAST_6_MONTHS"
        }
      ],
      "concreteType": "MetricDetailType",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '5c92ad48c3512f873e63fabd2ef12d32';
export default node;
